import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"

const allSignaturesQuery = graphql`
query allSignatures {
  dataJson {
    signatures {
      slug
      name
    }
  }
}
`

const Title = {
  textAlign: 'center',
  fontFamily: 'Arial',
  textTransform: 'uppercase'
}
const SignatureWrapper = {
  display: 'flex',
  fontFamily: 'Arial',
  justifyContent: 'center'
}
const LinkStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '10vw',
  width: '10vw',
  backgroundColor: 'rgba(0,0,0,0.1)',
  margin: '0 10px',
  padding: '20px',
  textDecoration: 'none',
  textAlign: 'center',
  color: 'red',
  fontWeight: 'bold',
  borderBottom: 'solid 2px red'
}


const IndexPage = () => (
  <StaticQuery
  query={allSignaturesQuery}
  render={data => (
    <>
      <h1 style={Title}>La Chiffrerie</h1>
      <div style={SignatureWrapper}>
        {data.dataJson.signatures.map(((signature, index) => (
          <div key={index}>
            <Link
              style={Object.assign({}, LinkStyle, {
                borderBottomColor: "#3bd4ae",
                color: "#3bd4ae"
              })}
              to={`/signatures/${signature.slug}`}>
              {signature.name}
            </Link>
          </div>
        )))}
      </div>
    </>
  )} />
)

export default IndexPage
